import React from "react";

const SunkenPanel = ({ children }) => (
  <div
    className="relative h-full w-full border-[0.100rem]
                border-t-[#7f787e] border-l-[#7f787e]
                border-b-[#ffffff] border-r-[#ffffff]"
  >
    <div
      className="absolute inset-0 border-[0.063rem]
                  border-t-[#2A282B] border-l-[#2A282B]
                  border-b-[#ABA6AB] border-r-[#ABA6AB]
                  bg-white"
    >
      {children}
    </div>
  </div>
);

export default SunkenPanel;
